import React, { useState } from 'react';
import Select from 'react-select';
import { Label } from 'reactstrap';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children: React.ReactNode;
}

const Checkbox: React.FC<CheckboxProps> = ({ children, ...props }) => (
  <label style={{ marginRight: '1em' }}>
    <input type="checkbox" {...props} />
    {children}
  </label>
);

interface Option {
  value: string;
  label: string;
}

interface BaseSelectDropdownProps {
  className : string;
  classNamePrefix :string;
  isDisabled: boolean;
  isLoading : boolean;
  name: string;
  options: Option[];
  onChange: {}
  value?: { value: string; label: string };
  isClearable?:boolean
  onBlur?: (e: React.FocusEvent<any>) => void; 
  required?: boolean;
  label?: string;
  error?: string;
  touched?: boolean;


}

const BaseSelectDropdown: React.FC<BaseSelectDropdownProps> = ({ 
  touched,
  className,classNamePrefix,isDisabled,isLoading,name,options,onChange,value,isClearable,required,label,error,
}) => {

  return (
    <>
          {label && (
        <>
          <Label for={name}>
            {label}
            {required && <span className="text-danger">*</span>}
          </Label>
        
        </>
      )}
      <Select
        className={className}
        classNamePrefix={classNamePrefix}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable
        name={name}
        options={options}
        onChange={onChange}
        value={value}
        invalid={!!(error && touched)}

      />
     {touched && error && <span className="text-danger errtxt">{error}</span>}
    </>
  );
};

export default BaseSelectDropdown;
